import alt from 'framework/alt';

// @TODO AUTHOR-10826: Delete once Redux can be used
class SitewideNotificationStore {
  constructor() {
    this.state = {
      notificationStringId: null,
    };

    this.on('bootstrap', () => {
      this.state.notificationStringId = this.state.sitewide_notification;
      delete this.state.sitewide_notification;
    });
  }
}

export default alt.createStore(SitewideNotificationStore, 'SitewideNotificationStore');
